import { AppEndpoint } from "app/app.endpoints";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { share } from "rxjs/operators";

@Injectable({ providedIn: "root" })
export class HttpRequestService {
  constructor(private http: HttpClient) {}

  public get(url: string) {
    return this.http.get(url);
  }

  public post(url: string, body?: any, httpOptions?: any) {
    return this.http.post(url, body, httpOptions);
  }

  public put(url: string, body?: any, httpOptions?: any) {
    return this.http.put(url, body, httpOptions);
  }

  public delete(url: string) {
    return this.http.delete(url);
  }

  operationsBuilder(url: string) {
    return {
      get: (httpOptions?) => this.http.get(url, httpOptions).pipe(share()),
      post: (body?, httpOptions?) =>
        this.http.post(url, body, httpOptions).pipe(share()),
      put: (body?, httpOptions?) =>
        this.http.put(url, body, httpOptions).pipe(share()),
      remove: (httpOptions?) =>
        this.http.delete(url, httpOptions).pipe(share()),
    };
  }
  ob = this.operationsBuilder;

  // eslint-disable-next-line @typescript-eslint/naming-convention
  Login = () => this.operationsBuilder(AppEndpoint.URL_API_LOGIN);
  Logout = () => this.operationsBuilder(AppEndpoint.URL_API_LOGOUT);
  ForgotPassword = () =>
    this.operationsBuilder(AppEndpoint.URL_API_FORGOT_PASSWORD);
  RestorePassword = () =>
    this.operationsBuilder(AppEndpoint.URL_API_RESTORE_PASSWORD);
  ValidateOTP = () => this.operationsBuilder(AppEndpoint.URL_API_VALIDATE_OTP);
  SendDetailReportt = () => this.operationsBuilder(AppEndpoint.URL_API_REPORT);
  SendDetailReport = (
    companyId?: string,
    startDate?: string,
    endDate?: string
  ) =>
    this.operationsBuilder(
      AppEndpoint.UrlDetailReport +
        "/" +
        companyId +
        "/" +
        startDate +
        "/" +
        endDate
    );

  Roles = (companyId?: string) =>
    this.operationsBuilder(AppEndpoint.UrlApiRole + "/" + companyId);

  Logo = (companyId?: string, id?: string) =>
    this.operationsBuilder(
      id != null
        ? AppEndpoint.UrlApiLogo + "/" + companyId + "/" + id
        : AppEndpoint.UrlApiLogo + "/" + companyId
    );
  Customer = (companyId?: string, id?: string) =>
    this.operationsBuilder(
      id != null
        ? AppEndpoint.UrlApiCustomer + "/" + companyId + "/" + id
        : AppEndpoint.UrlApiCustomer + "/" + companyId
    );
  Customers = (companyId?: string) =>
    this.operationsBuilder(AppEndpoint.UrlApiCustomers + "/" + companyId);
  ValidateCustomer = (companyId?: string, name?: string) =>
    this.operationsBuilder(
      AppEndpoint.UrlApiValidateCustomer + "/" + companyId + "/" + name
    );

  Route = (companyId?: string, id?: string) =>
    this.operationsBuilder(
      id != null
        ? AppEndpoint.UrlApiRoute + "/" + companyId + "/" + id
        : AppEndpoint.UrlApiRoute + "/" + companyId
    );
  Routes = (companyId?: string) =>
    this.operationsBuilder(AppEndpoint.UrlApiRoutes + "/" + companyId);

  BlackList = (companyId?: string, id?: string) =>
    this.operationsBuilder(
      id != null
        ? AppEndpoint.UrlApiBlackList + "/" + companyId + "/" + id
        : AppEndpoint.UrlApiBlackList + "/" + companyId
    );
  BlackLists = (companyId?: string) =>
    this.operationsBuilder(AppEndpoint.UrlApiBlackList + "/" + companyId);

  Countries = (companyId?: string) =>
    this.operationsBuilder(AppEndpoint.UrlApiCountries + "/" + companyId);
  CountriesAvailable = (companyId?: string) =>
    this.operationsBuilder(
      AppEndpoint.UrlApiCountriesAvailable + "/" + companyId
    );

  File = (companyId?: string, id?: string) =>
    this.operationsBuilder(
      id != null
        ? AppEndpoint.file + "/" + companyId + "/" + id
        : AppEndpoint.file + "/" + companyId
    );
  SendFile = (companyId?: string, id?: string) =>
    this.operationsBuilder(AppEndpoint.file + "/" + companyId + "/" + id
    );
  Image = (companyId?: string, id?: string) =>
    this.operationsBuilder(
      id != null
        ? AppEndpoint.imageSend + "/" + companyId + "/" + id
        : AppEndpoint.imageSend + "/" + companyId
    );
  Loading = (companyId?: string, id?: string) =>
    this.operationsBuilder(
      id != null
        ? AppEndpoint.loadingImage + "/" + companyId + "/" + id
        : AppEndpoint.loadingImage + "/" + companyId
    );
  FileCancel = (companyId?: string, id?: string) =>
    this.operationsBuilder(
      id != null
        ? AppEndpoint.fileCancel + "/" + companyId + "/" + id
        : AppEndpoint.file + "/" + companyId
    );

  CancelScheduled = (companyId?: string, scheduledId?: string) =>
    this.operationsBuilder(
      `${AppEndpoint.cancelScheduled}/${companyId}/${scheduledId}`
    );

  ScheduledFilesList = (companyId: string, params: any) =>
    this.http.get(`${AppEndpoint.scheduledFilesList}/${companyId}`, { params });

  File2 = (companyId?: string) =>
    this.operationsBuilder(AppEndpoint.file + "-create/" + companyId);

  Plan = (companyId?: string, id?: string) =>
    this.operationsBuilder(
      id != null
        ? AppEndpoint.UrlApiPlan + "/" + companyId + "/" + id
        : AppEndpoint.UrlApiPlan + "/" + companyId
    );
  Plans = (companyId?: string) =>
    this.operationsBuilder(AppEndpoint.UrlApiPlans + "/" + companyId);

  ThemeConfig = (companyId?: string, id?: string) =>
    this.operationsBuilder(
      id != null
        ? AppEndpoint.UrlApiThemeConfig + "/" + companyId + "/" + id
        : AppEndpoint.UrlApiThemeConfig + "/" + companyId
    );
  ThemeConfigs = (companyId?: string) =>
    this.operationsBuilder(AppEndpoint.UrlApiThemeConfigs + "/" + companyId);

  PublicThemeConfigs = () =>
    this.operationsBuilder(AppEndpoint.UrlApiPublicThemeConfigs);
  Chat = (companyId?: string, id?: string) =>
    this.operationsBuilder(
      id != null
        ? AppEndpoint.UrlApiChat + "/" + companyId + "/" + id
        : AppEndpoint.UrlApiChat + "/" + companyId
    );
  Chats = (companyId?: string, id?: string) =>
    this.operationsBuilder(
      id != null
        ? AppEndpoint.UrlApiChats + "/" + companyId + "/" + id
        : AppEndpoint.UrlApiChats + "/" + companyId
    );
  ChatSend = (companyId?: string, id?: string) =>
    this.operationsBuilder(
      id != null
        ? AppEndpoint.UrlApiChat + "/" + companyId + "/" + id
        : AppEndpoint.UrlApiChat + "/" + companyId
    );

  Permission = (companyId?: string, id?: string) =>
    this.operationsBuilder(
      id != null
        ? AppEndpoint.UrlApiPermission + "/" + companyId + "/" + id
        : AppEndpoint.UrlApiPermission + "/" + companyId
    );
  Permissions = (companyId?: string) =>
    this.operationsBuilder(AppEndpoint.UrlApiPermissions + "/" + companyId);
  PermissionExists = (companyId?: string) =>
    this.operationsBuilder(
      AppEndpoint.UrlApiPermissionExists + "/" + companyId
    );
  PermissionUpdateUser = (companyId: string, userId: string) =>
    this.operationsBuilder(
      AppEndpoint.UrlApiPermissionUpdateUser + "/" + companyId + "/" + userId
    );
  SuperPermissions = (companyId?: string) =>
    this.operationsBuilder(
      AppEndpoint.UrlApiSuperPermissions + "/" + companyId
    );

  Inbox = (companyId?: string, id?: string) =>
    this.operationsBuilder(
      id != null
        ? AppEndpoint.UrlApiInbox + "/" + companyId + "/" + id
        : AppEndpoint.UrlApiInbox + "/" + companyId
    );
  Inboxs = (companyId?: string) =>
    this.operationsBuilder(AppEndpoint.UrlApiInboxs + "/" + companyId);
  SuperInboxs = (companyId?: string) =>
    this.operationsBuilder(AppEndpoint.UrlApiSuperInboxs + "/" + companyId);

  Sender = (id?: string) =>
    this.operationsBuilder(
      id != null
        ? AppEndpoint.UrlApiSender + "/create" + id
        : AppEndpoint.UrlApiSender + "/create"
    );
  SenderWithoutCompany = (companyId?: string) =>
    this.operationsBuilder(
      AppEndpoint.UrlApiSenderWithoutCompany + "/" + companyId
    );
  SenderByCompany = (companyId?: string, id?: string) =>
    this.operationsBuilder(
      id != null
        ? AppEndpoint.UrlApiCompanySender + "/" + companyId + "/" + id
        : AppEndpoint.UrlApiSender + "/" + companyId
    );
  CustomerSender = (companyId?: string, id?: string) =>
    this.operationsBuilder(
      id != null
        ? AppEndpoint.UrlApiCustomerSender + "/" + companyId + "/" + id
        : AppEndpoint.UrlApiCustomerSender + "/" + companyId
    );
  CustomerSenders = (companyId?: string, id?: string) =>
    this.operationsBuilder(
      id != null
        ? AppEndpoint.UrlApiCustomerSenderS + "/" + companyId + "/" + id
        : AppEndpoint.UrlApiCustomerSenderS + "/" + companyId
    );

  Senders = (companyId?: string) =>
    this.operationsBuilder(AppEndpoint.UrlApiSenders + "/" + companyId);

  Subscription = (companyId?: string, id?: string) =>
    this.operationsBuilder(
      id != null
        ? AppEndpoint.UrlApiSubscription + "/" + companyId + "/" + id
        : AppEndpoint.UrlApiSubscription + "/" + companyId
    );
  Subscriptions = (companyId?: string) =>
    this.operationsBuilder(AppEndpoint.UrlApiSubscriptions + "/" + companyId);

  User = (companyId?: string, id?: string) =>
    this.operationsBuilder(
      id != null
        ? AppEndpoint.UrlApiUser + "/" + companyId + "/" + id
        : AppEndpoint.UrlApiUser + "/" + companyId
    );
  UserPassword = (companyId: string, action: string) =>
    this.operationsBuilder(`${AppEndpoint.UrlApiUser}-${action}/${companyId}`);
  UserAuthData = (companyId?: string, id?: string) =>
    this.operationsBuilder(
      id != null
        ? AppEndpoint.UrlApiUser + "-auth/" + companyId + "/" + id
        : AppEndpoint.UrlApiUser + "/" + companyId
    );
  Users = (companyId?: string, userId?: string) =>
    this.operationsBuilder(
      AppEndpoint.UrlApiUsers + "/" + companyId + "/" + userId
    );
  UsersByCompany = (currentCompany?: string) =>
    this.operationsBuilder(
      AppEndpoint.UrlApiUsers + "-by-company" + "/" + currentCompany
    );
  UsersByRole = (company?: string) =>
    this.operationsBuilder(
      AppEndpoint.UrlApiUsers + "-by-role" + "/" + company
    );
  Users2 = (companyId?: string) =>
    this.operationsBuilder(AppEndpoint.UrlApiUsers + "/" + companyId);
  Users3 = (companyId?: string) =>
    this.operationsBuilder(
      AppEndpoint.UrlApiUsers + "/per-company" + companyId
    );

  Send = (companyId?: string, id?: string) =>
    this.operationsBuilder(
      id != null
        ? AppEndpoint.UrlApiSend + "/" + companyId + "/" + id
        : AppEndpoint.UrlApiSend + "/" + companyId
    );
  SendWithPhonebook = (companyId: string) =>
    this.operationsBuilder(
      AppEndpoint.UrlApiSend + "-with-phonebook/" + companyId
    );

  Report = (companyId?: string, type = "") =>
    this.operationsBuilder(
      AppEndpoint.UrlReportSend +
        (type === "" ? type : `-${type}`) +
        "/" +
        companyId
    );
  SendSmsReport = (companyId?: string, startDate?: string, endDate?: string) =>
    this.operationsBuilder(
      AppEndpoint.UrlSendSmsReport +
        "/" +
        companyId +
        "/" +
        startDate +
        "/" +
        endDate
    );

  SendFiles = (
    companyId?: string,
    cId?: string,
    userId?: string,
    startDate?: string,
    endDate?: string
  ) =>
    this.operationsBuilder(
      AppEndpoint.UrlScheduledFilesReport +
        "/" +
        companyId +
        "/" +
        cId +
        "/" +
        userId +
        "/" +
        startDate +
        "/" +
        endDate
    );
  SendRecipientReport = (
    companyId?: string,
    msisdn?: string,
    startDate?: string,
    endDate?: string
  ) =>
    this.operationsBuilder(
      AppEndpoint.UrlSendRecipientReport +
        "/" +
        companyId +
        "/" +
        msisdn +
        "/" +
        startDate +
        "/" +
        endDate
    );
  SendDetail = (companyId?: string, cId?: string, fileId?: string) =>
    this.operationsBuilder(
      AppEndpoint.UrlSendDetail + "/" + companyId + "/" + cId + "/" + fileId
    );
  SendFirstDetail = (
    companyId?: string,
    cId?: string,
    fileId?: string,
    limit?: number
  ) =>
    this.operationsBuilder(
      AppEndpoint.UrlSendDetail +
        "/" +
        companyId +
        "/" +
        cId +
        "/" +
        fileId +
        "/" +
        String(limit)
    );
  SendDetailByUserDate = (
    companyId?: string,
    userId?: string,
    startDate?: string,
    endtDate?: string
  ) =>
    this.operationsBuilder(
      AppEndpoint.UrlSendDetailUserDate +
        "/" +
        companyId +
        "/" +
        userId +
        "/" +
        startDate +
        "/" +
        endtDate
    );
  FirstMessagesSent = (
    companyId?: string,
    userId?: string,
    startDate?: string,
    endtDate?: string,
    limit?: number
  ) =>
    this.operationsBuilder(
      AppEndpoint.UrlSendDetailUserDate +
        "/" +
        companyId +
        "/" +
        userId +
        "/" +
        startDate +
        "/" +
        endtDate +
        "/" +
        String(limit)
    );

  DownlaodReport = (
    companyId?: string,
    startDate?: string,
    endDate?: string,
    clientName?: string
  ) =>
    this.operationsBuilder(
      AppEndpoint.UrlDownloadReportSend +
        "/" +
        companyId +
        "/" +
        startDate +
        "/" +
        endDate +
        "/" +
        clientName
    );

  DailySendDashboard = (
    companyId?: string,
    userId?: string,
    startDate?: string,
    endDate?: string
  ) =>
    this.operationsBuilder(
      AppEndpoint.UrlApiDailySendDashboard +
        "/" +
        companyId +
        "/" +
        userId +
        "/" +
        startDate +
        "/" +
        endDate
    );
  SuperDailySendDashboard = (
    companyId?: string,
    startDate?: string,
    endDate?: string
  ) =>
    this.operationsBuilder(
      AppEndpoint.UrlApiSuperDailySendDashboard +
        "/" +
        companyId +
        "/" +
        startDate +
        "/" +
        endDate
    );
  YearSendDashboard = (
    companyId?: string,
    userId?: string,
    startDate?: string,
    endDate?: string
  ) =>
    this.operationsBuilder(
      AppEndpoint.UrlApiYearSendDashboard +
        "/" +
        companyId +
        "/" +
        userId +
        "/" +
        startDate +
        "/" +
        endDate
    );
  SuperYearSendDashboard = (
    companyId?: string,
    startDate?: string,
    endDate?: string
  ) =>
    this.operationsBuilder(
      AppEndpoint.UrlApiSuperYearSendDashboard +
        "/" +
        companyId +
        "/" +
        startDate +
        "/" +
        endDate
    );
  YearSendPerCompanyDashboard = (
    companyId?: string,
    startDate?: string,
    endDate?: string
  ) =>
    this.operationsBuilder(
      AppEndpoint.UrlApiYearSendPerCompanyDashboard +
        "/" +
        companyId +
        "/" +
        startDate +
        "/" +
        endDate
    );
  SendTypeDashboard = (companyId?: string) =>
    this.operationsBuilder(
      AppEndpoint.UrlApiSendTypeDashboard + "/" + companyId
    );
  GetScheduledFiles = (companyId?: string, userId?: string) =>
    this.operationsBuilder(
      AppEndpoint.UrlApiGetScheduledFile + "/" + companyId + "/" + userId
    );
  SendInOutPlanDashboard = (
    companyId?: string,
    startDate?: string,
    endDate?: string
  ) =>
    this.operationsBuilder(
      AppEndpoint.UrlApiGetSendInOutPlan +
        "/" +
        companyId +
        "/" +
        startDate +
        "/" +
        endDate
    );
  GetCompanyByMonthDashboard = (companyId?: string) =>
    this.operationsBuilder(
      AppEndpoint.UrlApiGetCompanyByMonth + "/" + companyId
    );

  // * ================================================ BLACKOUT ================================================
  Blackout = (companyId: string, userId = "") =>
    this.ob(
      `${AppEndpoint.UrlApiBlackout}/${companyId}${userId ? "/" + userId : ""}`
    );
  Blackouts = (companyId: string) =>
    this.ob(`${AppEndpoint.UrlApiBlackouts}/${companyId}`);

  // * ================================================ PHONEBOOK ================================================
  Phonebook = (companyId: string, userId = "") =>
    this.ob(
      `${AppEndpoint.UrlApiPhonebook}/${companyId}${userId ? "/" + userId : ""}`
    );
  Phonebooks = (companyId: string, userId = "") =>
    this.ob(
      `${AppEndpoint.UrlApiPhonebooks}/${companyId}${
        userId ? "/" + userId : ""
      }`
    );
  PhonebooksByCount = (companyId: string, count: number) =>
    this.ob(
      `${AppEndpoint.UrlApiPhonebooks}-by-count/${companyId}${
        count ? "/" + count : ""
      }`
    );
  PhonebooksByCompany = (companyId: string) =>
    this.ob(`${AppEndpoint.UrlApiPhonebooks}-by-company/${companyId}`);

  // * ================================================ CONTACT GROUP ================================================
  ContactGroup = (companyId: string, userId = "") =>
    this.ob(
      `${AppEndpoint.UrlApiContactGroup}/${companyId}${
        userId ? "/" + userId : ""
      }`
    );
  ContactsGroup = (companyId: string, userId = "") =>
    this.ob(
      `${AppEndpoint.UrlApiContactsGroup}/${companyId}${
        userId ? "/" + userId : ""
      }`
    );

  // * ================================================ CONTACT ================================================
  Contact = (companyId: string, userId = "") =>
    this.ob(
      `${AppEndpoint.UrlApiContact}/${companyId}${userId ? "/" + userId : ""}`
    );
  Contacts = (companyId: string, userId = "") =>
    this.ob(
      `${AppEndpoint.UrlApiContacts}/${companyId}${userId ? "/" + userId : ""}`
    );
  ContactsByPhonebook = (companyId: string, phonebookId: string) =>
    this.ob(
      `${AppEndpoint.UrlApiContacts}-by-phonebooks/${companyId}/${phonebookId}`
    );
  ContactsTotalByPhonebook = (companyId: string, phonebookId: string) =>
    this.ob(
      `${AppEndpoint.UrlApiContacts}-count-by-phonebooks/${companyId}/${phonebookId}`
    );
  ContactWithPhone = (companyId: string, phone: string) =>
    this.ob(`${AppEndpoint.UrlApiContacts}-by-phone/${companyId}/${phone}`);

  // * ============================================= DAILY SEND LOG ============================================
  DailyLogData = (companyId: string, type: string) =>
    this.ob(`${AppEndpoint.UrlApiDailyLogData}-${type}/${companyId}`);
  DailyLogReport = (companyId: string, type: string) =>
    this.ob(`${AppEndpoint.UrlApiContact}/${companyId}`);

  // * ============================================= INVOICES ===============================================
  Invoice = (companyId: string, action = "") =>
    this.ob(
      `${AppEndpoint.UrlApiInvoice}${
        action === "" ? action : "-" + action
      }/${companyId}`
    );
}
